export const FETCH_SCHOOL_SUCCESS = 'FETCH_SCHOOL_SUCCESS';
